module.exports = __webpack_public_path__ + "static/media/undraw_horror_movie_3988.a8de6ac3.svg";